"use client";

import React from "react";
import { FiAlertCircle } from "react-icons/fi";
import classNames from "classnames";
import { InputThemePickerProps } from "./types";
import { ConnectForm } from "@/utils/formHelper";
import { ColorPicker } from "../../ColorPicker";

import "./styles.scss";

/**
 * Componente específico para manejo de themes
 *
 * @note Este componente es una versión modificada de Input
 *       con lógica específica para themes. La duplicación es necesaria ya que
 *       la lógica original no puede ser reutilizada directamente.
 */
export const InputThemePicker = ({
  id,
  label,
  type,
  placeholder,
  errorMessage,
  error,
  className,
  name,
  colorPicker,
  colorPickerWithDebounce = false,
  onChange,
  value,
  defaultColorValue,
}: InputThemePickerProps) => {
  const classnames = classNames(`Input`, {
    [`Input--${className}`]: className,
    "Input--error": error,
    "Input--colorPicker": colorPicker !== undefined,
  });

  return (
    <div
      data-testid="input-theme-picker"
      data-qa="input-theme-picker"
      className={classnames}>
      <div className="Input__label-container">
        {label && (
          <label
            data-testid="input-theme-picker-label"
            htmlFor={id}
            className="Input__label">
            {label || ""}
          </label>
        )}
      </div>

      <div className="Input__wrapper">
        <ConnectForm>
          <input
            data-testid="input-theme-picker-element"
            data-qa="input-theme-picker-element"
            className="Input__element"
            id={id}
            type={type}
            placeholder={placeholder}
            name={name}
            onClick={(e) => e.stopPropagation()}
            onChange={onChange}
            autoComplete="off"
            value={value}
          />
        </ConnectForm>

        <ColorPicker
          id={id}
          color={value}
          defaultColorValue={defaultColorValue}
          withDebounce={colorPickerWithDebounce}
          onChange={onChange}
        />
      </div>

      {error && (
        <p
          data-testid="input-theme-picker-error-message"
          data-qa="input-theme-picker-error-message"
          className="Input__error-message body-s">
          <FiAlertCircle />
          {errorMessage as string}
        </p>
      )}
    </div>
  );
};
